import { CustomRoleForUser } from "@/common/customRole";
import { TMessageKey } from "@/i18n/types.gen";

export enum OnboardingStatus {
  incomplete = "incomplete",
  complete = "complete",
}

export type OnboardingStatusResponse = {
  articlesOfAssociation: OnboardingStatus;
  shareholderRegister: OnboardingStatus;
  settings: OnboardingStatus;
  payment: OnboardingStatus;
};

export enum OnboardingSaveStatus {
  LOADING = "loading",
  IDLE = "idle",
}

export type OnboardingError = {
  validationError: TMessageKey;
  context: string;
};

export const shareholderErrors = new Map<string, TMessageKey>([
  ["invalidSocialSecurityNumber", "onboarding.step.error.invalidSocialSecurityNumber"],
  ["missingOrganisationNumber", "onboarding.step.error.missingOrganisationNumber"],
  ["shareholdersMissing", "onboarding.step.error.shareholders.shareholder.missing"],
]);

export function isOnboardingComplete(onboardingSteps: OnboardingStatusResponse) {
  return (
    onboardingSteps.articlesOfAssociation === OnboardingStatus.complete &&
    onboardingSteps.shareholderRegister === OnboardingStatus.complete &&
    onboardingSteps.settings === OnboardingStatus.complete
  );
}

export function canCompleteOnboardingStep(
  onboardingSteps: OnboardingStatusResponse,
  userRole: CustomRoleForUser | undefined,
) {
  return (
    (onboardingSteps.articlesOfAssociation !== OnboardingStatus.complete &&
      userRole?.allowArticlesEdit) ||
    (onboardingSteps.shareholderRegister !== OnboardingStatus.complete &&
      userRole?.allowShareholdersEdit) ||
    (onboardingSteps.settings !== OnboardingStatus.complete && userRole?.allowCompanySettingsEdit)
  );
}
